import React from 'react';
import PropTypes from 'prop-types';
import { Step, Stepper, StepLabel } from '@material-ui/core';

export default function WorkflowStepper({
  isHidden,
  activeStep,
  steps,
  className
}) {
  if (isHidden) return null;

  return (
    <Stepper activeStep={activeStep} className={className}>
      {steps.map((step) => (
        <Step key={step}>
          <StepLabel>{step}</StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}

WorkflowStepper.propTypes = {
  isHidden: PropTypes.bool,
  activeStep: PropTypes.number,
  steps: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string
}
